import React from 'react'
import {
  BlockList,
  generateBackgroundStyles,
  generateColorThemeClasses,
  generatePaddingClasses,
  SectionSettingsProps,
  generateTopRadiusClasses,
  generateColumnClasses,
} from '.'

export const SectionTwoColumnBlock = (props: SectionSettingsProps) => {
  const { areas } = props

  const leftArea = areas?.find(area => area?.name === 'Left')
  const rightArea = areas?.find(area => area?.name === 'Right')

  const backgroundStyles = generateBackgroundStyles(props)
  const colorThemeClasses = generateColorThemeClasses(props)
  const paddingClasses = generatePaddingClasses(props)
  const colClass = generateColumnClasses({ ...props, sectionType: 'double' })
  const topRadiusClasses = generateTopRadiusClasses(props)

  return (
    <div
      style={backgroundStyles}
      className={`${colorThemeClasses} ${paddingClasses} ${topRadiusClasses}`}
      data-block-section>
      <div className="container">
        <div className="row">
          {leftArea && (
            <div className={`col-12 ${colClass.firstCol}`}>
              <BlockList blocks={leftArea.blocks} availableColumns={6} />
            </div>
          )}
          {rightArea && (
            <div className={`col-12 ${colClass.secondCol}`}>
              <BlockList blocks={rightArea.blocks} availableColumns={6} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
